import { GET_USER_ENTITLEMENTS_SUCCESS } from 'constants/ActionTypes';

export default (state = null, action = {}) => {
  switch (action.type) {
    case GET_USER_ENTITLEMENTS_SUCCESS: return action.entitlements;
    default: return state;
  }
};
